import axios from 'axios';
import Bouncer from 'formbouncerjs/src/js/bouncer/bouncer';

const helpers = window.BASE_HELPERS || {};
const { Forms, MessageBox } = helpers;

const MODULE = document.querySelectorAll('[data-module="newsletter"]');

class Newsletter {
    constructor() {
        this.components = MODULE;
        this.init();
    }

    init() {
        this.components.forEach(component => {

            const FORM = component.querySelector('.newsletter');

            new Bouncer('.newsletter', {
                disableSubmit: true,
                messageAfterField: false,
                messages: {
                    missingValue: {
                        default: 'Campo de preenchimento obrigatório',
                    },
                    patternMismatch: {
                        email: 'Por favor, insira um e-mail válido',
                    },
                },
                emitEvents: true,
            });

            FORM.addEventListener('bouncerShowError', (event) => {
                FORM.classList.add('has-message');
            });

            FORM.addEventListener('bouncerRemoveError', (event) => {
                FORM.classList.remove('has-message');
            });

            FORM.addEventListener('bouncerFormValid', async (event) => {
                event.preventDefault();

                const formEl = event.target;
                const submitEl = formEl.querySelector('[type="submit"]');
                submitEl?.setAttribute('disabled', 'disabled');
                FORM.classList.remove('has-message');

                window.reloadCaptcha('submit', 'recaptcha_token', async () => {
                    const payload = new FormData(formEl);

                    try {
                        const url = `${AppSettings.baseApiUrl}basedigital/v1/newsletter`;
                        const response = await axios.post(url, payload, { timeout: 30000 });

                        MessageBox.showOnce({
                            target: FORM,
                            position: 'bottom',
                            type: 'success',
                            message: i18n.message.formNewsletterSuccess,
                            classes: 'text-xs text-secundaria-verde-sustentavel',
                            timeout: 8000,
                        });
                    } catch (e) {
                        console.error(e);
                    } finally {
                        formEl.reset();
                        submitEl?.removeAttribute('disabled');
                        setTimeout(() => {
                            FORM.classList.remove('has-message');
                        }, 5000)
                    }
                });
            });
        });
    }
}

(() => {
    if (MODULE) {
        new Newsletter();
    }
})();

export default Newsletter;
